// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Poppins";
  src: url("https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap");
  font-display: swap; /* Ensure text is rendered with fallback font until the font loads */
}

body {
  font-family: "Poppins", sans-serif;
}
:root {
  --primary: #ff6036;
  --white: #ffffff;
  --gray: #ffffff66;
  --black: #1e1e1e;
  --pink: #ffede8;
}
.container {
  max-width: 1170px;
  margin: auto;
}
.row {
  display: flex;
  flex-wrap: wrap;
}
hr {
  margin: 1rem 0 0 0;
}
a {
  text-decoration: none;
}
.split-heading {
  display: flex;
  flex-direction: column;
}
.card-row {
  margin-top: 1.5rem;
}
.success {
  width: 30px;
  height: 30px;
}
.success-small {
  width: 26px;
  height: 26px;
}
.gif-image img {
  width: 120px;
  height: 120px;
}
.navbar-nav {
  cursor: pointer;
}
.navbar-brand {
  cursor: pointer;
}
.svg-container-home {
  display: flex;
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-left: 4px;
}
.start-free-trial-orange-button button {
  border-radius: 25px;
  background-color: rgb(255, 96, 54);
  color: rgb(255, 255, 255);
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid rgb(255, 96, 54);
  font-weight: 400;
  font-size: 16px;
  height: 44px;
  transition: all 0.5s;
  cursor: pointer;
  position: relative;
}

.plain-button button {
  border-radius: 25px;
  border: none !important;
  background-color: white;
  color: rgb(0, 0, 0);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 400;
  font-size: 16px;
  height: 44px;
  transition: all 0.5s;
  cursor: pointer;
  position: relative;
}

.start-free-trial-orange-button button:hover {
  background-color: white;
  color: black;
  border: 1px solid black;
}
.header-below-content-part {
  text-align: left;
  max-width: 90%;
  margin: 0;
}
.header-below-content-part h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

/* Center Title section */
.center-title-part {
  max-width: 72%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: auto;
}

.center-title-part h2 {
  font-weight: 600;
  font-size: 38px;
}

.center-title-part p {
  margin-top: 15px;
}

/* single gif section */
.clinic-gif-content h2,
.security-reliability-gif-content h2,
.virtue-life-badge-gif-content h2,
.hep-features-gif-content h2 {
  font-weight: 600;
  font-size: 38px;
}
.clinic-gif-content p,
.security-reliability-gif-content p,
.virtue-life-badge-gif-content p,
.hep-features-gif-content p {
  margin-top: 15px;
}
/* try VirtueLife today section */
.try-virtue-life-today-section {
  padding: 4rem 0;
}
.try-virtue-life-today-card {
  background: #ff6036;
  border-radius: 18px;
}
.try-virtue-life-today-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.try-virtue-life-today-heading {
  margin: 0;
  font: 600 28px/39px Poppins, sans-serif;
  color: white;
}
.try-virtue-life-today-text {
  margin: 0;
  margin-top: 16px;
  font: 600 38px/53px Poppins, sans-serif;
  color: white;
  text-align: center;
}
.try-virtue-life-today-button {
  border-radius: 25px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  font-weight: 600;
  font-size: 16px;
}
.try-virtue-life-today-button:hover {
  color: white;
  background-color: #000;
}

.store-name button {
  border-radius: 25px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  font-weight: 500;
  height: 44px;
  font-size: 16px;
  position: relative;
}

.store-name button:hover {
  background-color: black;
  color: white;
}

/* Unified Communication & Profile Management for Doctors section */
.ucpm-doctors-section {
  padding: 4rem 0;
}
.ucpm-doctor-card {
  background-color: var(--white);
  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);
  padding: 1.56rem;
  border-radius: 14px;
  display: flex;
  text-align: start;
}

.ucpm-doctor-card h5 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 26px;
}
.ucpm-doctor-card p {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
  color: black;
}

/* step-section */
.step-section {
  padding: 4rem 0;
}
.step-section-data-card-grid {
  padding-left: 0;
  padding-right: 0;
}

.custom-card-step-section {
  background-color: #fffaf8;
  padding: 1.56rem;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  text-align: start;
}
.custom-card-step-section h5 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #ff4817;
}
.number-margin {
  margin: 0px;
}
.dashed-border-bottom {
  border-bottom: 1px dashed black;
}
.highlighted-content-container {
  display: flex;
  justify-content: space-between;
  height: 71px;
}
.step-section-sequential-number-list {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #fffaf8;
  color: #ff5722;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 42px;
  font-weight: 700;
  margin: 0;
}

.custom-card-step {
  background-color: #ffffff;
  padding: 1.56rem;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  text-align: start;
}
.custom-card-step h5 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #ff4817;
}
.dash-bottom,
.dash-card2-bottom {
  border-bottom: 1px dashed black;
}
.dashed-border-left {
  border-left: 1px dashed black;
}
.w-0 {
  width: 0;
}

.virtue-life-core-values-section {
  padding: 4rem 0;
}
.healthcare-systems-ul {
  display: flex;
  justify-content: center;
}
.desktop-mobile-section {
  padding: 4rem 0;
}

/* title-part section */
.exercise-protocol-title-part {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 10px 0;
}
.exercise-protocol-title-part h2,
.exercise-title-part h2 {
  font-weight: 600;
  font-size: 32px;
}
.exercise-protocol-title-part p {
  margin-top: 15px;
}

.desktop-mobile-section .desktop-mobile-list-part ul {
  margin-top: 20px;
  margin-bottom: 40px;
  list-style-type: none;
  display: flex;
}

.app-play-button .appStore img,
.app-play-button .playStore img {
  width: 144px;
  height: 44px;
}

.app-play-button .appStore,
.app-play-button .playStore {
  border: 0;
  background-color: transparent;
  text-align: start;
}

.banner-image {
  width: auto;
}

.desktop-mobile-patient li {
  margin: 10px 0;
  font-size: 16px;
  display: flex;
}

/* global-scale section  */
.global-scale-card {
  display: flex;
  gap: 21px;
  align-items: center;
  padding: 30px 29px;
  margin-top: 30px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

.global-scale-card-info {
  flex: 0 0 auto;
}

.global-scale-statistic-text {
  margin: 0;
  font: 700 48px/60px Poppins, sans-serif;
  color: white;
}

.global-scale-statistic-name {
  margin: 0;
  margin-top: 10px;
  font: 500 16px Poppins, sans-serif;
  color: white;
}

.global-scale-vertical-divider {
  height: 80px;
  border-left: 1px solid white;
}

.global-scale-button {
  display: block;
  min-width: 215px;
  height: 44px;
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 25px;
  color: white;
  cursor: pointer;
}
.global-scale-button:hover {
  background-color: white;
  color: black;
}
.global-scale-section {
  background-color: #000;
  background-size: 100% 100%;
  padding: 4rem 0;
}

.global-text {
  color: rgba(255, 255, 255, 0.6);
}

.global-scale-title-part {
  text-align: left;
  max-width: 100%;
}

.global-scale-title-part h2 {
  font-size: 38px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 53px;
}

.global-scale-title-part p {
  font-size: 16px;
  font-weight: 400;
}

.global-scale-title-part h2 {
  color: rgba(255, 255, 255, 1);
}

.global-scale-title-part p {
  color: rgba(255, 255, 255, 1);
}
.global-scale-content-part {
  padding: 4rem 0;
  padding-right: 58px;
}
@media screen and (min-width: 1200px) {
  .banner-image {
    position: absolute;
    right: 0;
    width: auto;
    padding: 0;
    top: 50%;
    transform: translate(5%, -50%);
    height: 642px;
    width: 748px;
  }
}
@media screen and (max-width: 1024px) {
}

@media screen and (max-width: 991px) {
}

@media screen and (max-width: 768px) {
  .image-part img {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 574px) {
  .success {
    width: 25px;
    height: 25px;
  }
  .success-small {
    width: 18px;
    height: 18px;
  }
  .gif-image img {
    width: 70px;
    height: 70px;
  }
  .start-free-trial-orange-button {
    width: 100%;
  }
  .start-free-trial-orange-button button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    width: 100%;
  }

  .header-below-content-part {
    text-align: center;
    max-width: 100%;
  }

  .header-below-content-part h1 {
    font-size: 24px;
  }
  .header-below-content-part p {
    font-size: 14px;
  }
  .image-part img {
    width: 100%;
    height: 100%;
  }
  .clinic-gif-content h2,
  .security-reliability-gif-content h2,
  .virtue-life-badge-gif-content h2,
  .hep-features-gif-content h2 {
    font-size: 24px;
  }
  .clinic-gif-content p,
  .security-reliability-gif-content p,
  .virtue-life-badge-gif-content p,
  .hep-features-gif-content p {
    font-size: 14px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .center-title-part {
    max-width: 100%;
  }
  .center-title-part h2 {
    font-size: 24px;
    line-height: 35px;
  }
  .center-title-part p {
    font-size: 14px;
    margin-top: 0px;
  }
  .next-card {
    margin-top: 1rem;
  }
  .image-part img {
    margin-top: 2rem;
  }
  .card-row {
    margin-top: 0rem;
  }
  .try-virtue-life-today-section {
    padding: 2rem 0;
  }
  .try-virtue-life-today-content {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .try-virtue-life-today-text {
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 16px;
  }
  .try-virtue-life-today-heading {
    font-size: 24px;
  }
  .store-name button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    width: 100%;
  }

  /* Unified Communication & Profile Management for Doctors section */
  .ucpm-doctors-section {
    padding: 2rem 0;
  }

  .ucpm-doctor-card {
    padding: 1rem;
  }
  .ucpm-doctor-card h5 {
    margin-bottom: 5px;
  }
  .ucpm-doctor-card p {
    font-size: 14px;
    margin-bottom: 0px;
  }
  /* step section */
  .step-section {
    padding: 2rem 0;
  }
  .step-section-data-card-grid {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
  .custom-card-step-section {
    padding: 1rem;
    margin: auto !important;
  }
  .custom-card-step-section h5 {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .custom-card-step-section p {
    font-size: 14px;
    margin-bottom: 0px !important;
  }
  .step-section-sequential-number-list {
    width: 50px;
    height: 50px;
    font-size: 30px;
  }
  .number-margin {
    margin: auto !important;
  }
  .step-button {
    margin-top: 1rem;
  }
  .step-button button {
    font-size: 14px;
    width: 100%;
  }

  .virtue-life-core-values-section {
    padding: 2rem 0;
  }
  .healthcare-systems-ul {
    display: block;
    padding: 0px;
  }
  .desktop-mobile-section {
    padding: 2rem 0;
  }
  .exercise-protocol-title-part h2 {
    font-size: 24px;
    text-align: center;
  }
  .exercise-protocol-title-part p {
    font-size: 14px;
    margin-top: 5px;
  }
  .desktop-mobile-section .desktop-mobile-list-part ul {
    display: block;
    margin-bottom: 15px;
    margin-top: 0px;
  }
  .app-play-button {
    display: flex;
    justify-content: center;
  }
  .popover {
    display: none !important;
  }
  .banner-image {
    display: flex !important;
    justify-content: center;
    padding-top: 2rem;
    width: 100%;
    height: 100%;
  }
  .desktop-mobile-patient li {
    font-size: 14px;
  }
  .global-scale-vertical-divider {
    height: 50px;
  }

  .global-scale-section {
    padding: 2rem 0;
  }

  .global-scale-title-part {
    text-align: center;
    max-width: 100%;
  }

  .global-scale-title-part h2 {
    font-size: 24px;
    line-height: 35px;
  }

  .global-scale-title-part p {
    font-size: 14px;
  }

  .global-scale-content-part,
  .streamlined-patient-section {
    padding: 2rem 0;
  }
  .global-scale-content-part {
    padding-top: 0px;
  }

  .global-scale-content-part .light-theme {
    padding: 0px;
  }

  .see-more-content {
    text-align: center;
  }

  .global-text {
    font-size: 14px;
    text-align: center;
  }

  .global-scale-button {
    width: 100%;
  }
  .global-scale-statistic-text {
    font-size: 20px;
    line-height: 40px;
  }

  .global-scale-card {
    padding: 15px 14px;
    gap: 20px;
    justify-content: center;
  }
  .global-scale-card-info {
    text-align: center;
  }

  .global-scale-statistic-name {
    font-size: 12px;
    margin-top: 0px;
    width: 70px;
  }
}

html,
body {
  max-width: 100% !important;
  overflow-x: hidden !important;
}


/* Default button style */
.accordion-button {
  background-color: #fff;
  color: #000; /* Black text by default */
  transition: background-color 0.3s ease, color 0.3s ease;
  box-shadow: none;
  border: none;
}

/* Hover effect — orange background, white text */
.accordion-button:hover {
  background-color: #aaaaaa; /* medium orange */
  color: #fff; /* white text on hover */
}

/* Active/expanded state — darker orange, white text */
.accordion-button:not(.collapsed) {
  background-color: #aaaaaa; /* deeper orange */
  color: #fff;
  box-shadow: none;
  border: none;
}

/* Remove all default focus/blue styles */
.accordion-button:focus,
.accordion-button:focus-visible {
  outline: none;
  box-shadow: none;
  border: none;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kHAAkH;EAClH,kBAAkB,EAAE,oEAAoE;AAC1F;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;;;;EAIE,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;EAIE,gBAAgB;AAClB;AACA,iCAAiC;AACjC;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,YAAY;EACd;AACF;AACA;AACA;;AAEA;AACA;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;;;IAIE,eAAe;EACjB;EACA;;;;IAIE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA,mEAAmE;EACnE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA,iBAAiB;EACjB;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;;AAGA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,WAAW,EAAE,0BAA0B;EACvC,uDAAuD;EACvD,gBAAgB;EAChB,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,WAAW,EAAE,wBAAwB;AACvC;;AAEA,sDAAsD;AACtD;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA,yCAAyC;AACzC;;EAEE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["@font-face {\r\n  font-family: \"Poppins\";\r\n  src: url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\r\n  font-display: swap; /* Ensure text is rendered with fallback font until the font loads */\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\", sans-serif;\r\n}\r\n:root {\r\n  --primary: #ff6036;\r\n  --white: #ffffff;\r\n  --gray: #ffffff66;\r\n  --black: #1e1e1e;\r\n  --pink: #ffede8;\r\n}\r\n.container {\r\n  max-width: 1170px;\r\n  margin: auto;\r\n}\r\n.row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\nhr {\r\n  margin: 1rem 0 0 0;\r\n}\r\na {\r\n  text-decoration: none;\r\n}\r\n.split-heading {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.card-row {\r\n  margin-top: 1.5rem;\r\n}\r\n.success {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n.success-small {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n.gif-image img {\r\n  width: 120px;\r\n  height: 120px;\r\n}\r\n.navbar-nav {\r\n  cursor: pointer;\r\n}\r\n.navbar-brand {\r\n  cursor: pointer;\r\n}\r\n.svg-container-home {\r\n  display: flex;\r\n  flex: 0 0 auto;\r\n  width: 10px;\r\n  height: 10px;\r\n  margin-left: 4px;\r\n}\r\n.start-free-trial-orange-button button {\r\n  border-radius: 25px;\r\n  background-color: rgb(255, 96, 54);\r\n  color: rgb(255, 255, 255);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  border: 1px solid rgb(255, 96, 54);\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  height: 44px;\r\n  transition: all 0.5s;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.plain-button button {\r\n  border-radius: 25px;\r\n  border: none !important;\r\n  background-color: white;\r\n  color: rgb(0, 0, 0);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  height: 44px;\r\n  transition: all 0.5s;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.start-free-trial-orange-button button:hover {\r\n  background-color: white;\r\n  color: black;\r\n  border: 1px solid black;\r\n}\r\n.header-below-content-part {\r\n  text-align: left;\r\n  max-width: 90%;\r\n  margin: 0;\r\n}\r\n.header-below-content-part h1 {\r\n  font-size: 48px;\r\n  font-weight: 700;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Center Title section */\r\n.center-title-part {\r\n  max-width: 72%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  margin: auto;\r\n}\r\n\r\n.center-title-part h2 {\r\n  font-weight: 600;\r\n  font-size: 38px;\r\n}\r\n\r\n.center-title-part p {\r\n  margin-top: 15px;\r\n}\r\n\r\n/* single gif section */\r\n.clinic-gif-content h2,\r\n.security-reliability-gif-content h2,\r\n.virtue-life-badge-gif-content h2,\r\n.hep-features-gif-content h2 {\r\n  font-weight: 600;\r\n  font-size: 38px;\r\n}\r\n.clinic-gif-content p,\r\n.security-reliability-gif-content p,\r\n.virtue-life-badge-gif-content p,\r\n.hep-features-gif-content p {\r\n  margin-top: 15px;\r\n}\r\n/* try VirtueLife today section */\r\n.try-virtue-life-today-section {\r\n  padding: 4rem 0;\r\n}\r\n.try-virtue-life-today-card {\r\n  background: #ff6036;\r\n  border-radius: 18px;\r\n}\r\n.try-virtue-life-today-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding-top: 4rem;\r\n  padding-bottom: 4rem;\r\n}\r\n.try-virtue-life-today-heading {\r\n  margin: 0;\r\n  font: 600 28px/39px Poppins, sans-serif;\r\n  color: white;\r\n}\r\n.try-virtue-life-today-text {\r\n  margin: 0;\r\n  margin-top: 16px;\r\n  font: 600 38px/53px Poppins, sans-serif;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n.try-virtue-life-today-button {\r\n  border-radius: 25px;\r\n  background-color: rgb(255, 255, 255);\r\n  color: rgb(0, 0, 0);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  border: none;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n.try-virtue-life-today-button:hover {\r\n  color: white;\r\n  background-color: #000;\r\n}\r\n\r\n.store-name button {\r\n  border-radius: 25px;\r\n  background-color: rgb(255, 255, 255);\r\n  color: rgb(0, 0, 0);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  border: none;\r\n  font-weight: 500;\r\n  height: 44px;\r\n  font-size: 16px;\r\n  position: relative;\r\n}\r\n\r\n.store-name button:hover {\r\n  background-color: black;\r\n  color: white;\r\n}\r\n\r\n/* Unified Communication & Profile Management for Doctors section */\r\n.ucpm-doctors-section {\r\n  padding: 4rem 0;\r\n}\r\n.ucpm-doctor-card {\r\n  background-color: var(--white);\r\n  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);\r\n  padding: 1.56rem;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  text-align: start;\r\n}\r\n\r\n.ucpm-doctor-card h5 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  line-height: 26px;\r\n}\r\n.ucpm-doctor-card p {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  margin-bottom: 10px;\r\n  color: black;\r\n}\r\n\r\n/* step-section */\r\n.step-section {\r\n  padding: 4rem 0;\r\n}\r\n.step-section-data-card-grid {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.custom-card-step-section {\r\n  background-color: #fffaf8;\r\n  padding: 1.56rem;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: start;\r\n}\r\n.custom-card-step-section h5 {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  color: #ff4817;\r\n}\r\n.number-margin {\r\n  margin: 0px;\r\n}\r\n.dashed-border-bottom {\r\n  border-bottom: 1px dashed black;\r\n}\r\n.highlighted-content-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 71px;\r\n}\r\n.step-section-sequential-number-list {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  background-color: #fffaf8;\r\n  color: #ff5722;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 42px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.custom-card-step {\r\n  background-color: #ffffff;\r\n  padding: 1.56rem;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: start;\r\n}\r\n.custom-card-step h5 {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  color: #ff4817;\r\n}\r\n.dash-bottom,\r\n.dash-card2-bottom {\r\n  border-bottom: 1px dashed black;\r\n}\r\n.dashed-border-left {\r\n  border-left: 1px dashed black;\r\n}\r\n.w-0 {\r\n  width: 0;\r\n}\r\n\r\n.virtue-life-core-values-section {\r\n  padding: 4rem 0;\r\n}\r\n.healthcare-systems-ul {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.desktop-mobile-section {\r\n  padding: 4rem 0;\r\n}\r\n\r\n/* title-part section */\r\n.exercise-protocol-title-part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  margin: auto;\r\n  padding: 10px 0;\r\n}\r\n.exercise-protocol-title-part h2,\r\n.exercise-title-part h2 {\r\n  font-weight: 600;\r\n  font-size: 32px;\r\n}\r\n.exercise-protocol-title-part p {\r\n  margin-top: 15px;\r\n}\r\n\r\n.desktop-mobile-section .desktop-mobile-list-part ul {\r\n  margin-top: 20px;\r\n  margin-bottom: 40px;\r\n  list-style-type: none;\r\n  display: flex;\r\n}\r\n\r\n.app-play-button .appStore img,\r\n.app-play-button .playStore img {\r\n  width: 144px;\r\n  height: 44px;\r\n}\r\n\r\n.app-play-button .appStore,\r\n.app-play-button .playStore {\r\n  border: 0;\r\n  background-color: transparent;\r\n  text-align: start;\r\n}\r\n\r\n.banner-image {\r\n  width: auto;\r\n}\r\n\r\n.desktop-mobile-patient li {\r\n  margin: 10px 0;\r\n  font-size: 16px;\r\n  display: flex;\r\n}\r\n\r\n/* global-scale section  */\r\n.global-scale-card {\r\n  display: flex;\r\n  gap: 21px;\r\n  align-items: center;\r\n  padding: 30px 29px;\r\n  margin-top: 30px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n}\r\n\r\n.global-scale-card-info {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.global-scale-statistic-text {\r\n  margin: 0;\r\n  font: 700 48px/60px Poppins, sans-serif;\r\n  color: white;\r\n}\r\n\r\n.global-scale-statistic-name {\r\n  margin: 0;\r\n  margin-top: 10px;\r\n  font: 500 16px Poppins, sans-serif;\r\n  color: white;\r\n}\r\n\r\n.global-scale-vertical-divider {\r\n  height: 80px;\r\n  border-left: 1px solid white;\r\n}\r\n\r\n.global-scale-button {\r\n  display: block;\r\n  min-width: 215px;\r\n  height: 44px;\r\n  margin-top: 20px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: none;\r\n  border-radius: 25px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n.global-scale-button:hover {\r\n  background-color: white;\r\n  color: black;\r\n}\r\n.global-scale-section {\r\n  background-color: #000;\r\n  background-size: 100% 100%;\r\n  padding: 4rem 0;\r\n}\r\n\r\n.global-text {\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.global-scale-title-part {\r\n  text-align: left;\r\n  max-width: 100%;\r\n}\r\n\r\n.global-scale-title-part h2 {\r\n  font-size: 38px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  line-height: 53px;\r\n}\r\n\r\n.global-scale-title-part p {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.global-scale-title-part h2 {\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.global-scale-title-part p {\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n.global-scale-content-part {\r\n  padding: 4rem 0;\r\n  padding-right: 58px;\r\n}\r\n@media screen and (min-width: 1200px) {\r\n  .banner-image {\r\n    position: absolute;\r\n    right: 0;\r\n    width: auto;\r\n    padding: 0;\r\n    top: 50%;\r\n    transform: translate(5%, -50%);\r\n    height: 642px;\r\n    width: 748px;\r\n  }\r\n}\r\n@media screen and (max-width: 1024px) {\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .image-part img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 574px) {\r\n  .success {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n  .success-small {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n  .gif-image img {\r\n    width: 70px;\r\n    height: 70px;\r\n  }\r\n  .start-free-trial-orange-button {\r\n    width: 100%;\r\n  }\r\n  .start-free-trial-orange-button button {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    width: 100%;\r\n  }\r\n\r\n  .header-below-content-part {\r\n    text-align: center;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .header-below-content-part h1 {\r\n    font-size: 24px;\r\n  }\r\n  .header-below-content-part p {\r\n    font-size: 14px;\r\n  }\r\n  .image-part img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .clinic-gif-content h2,\r\n  .security-reliability-gif-content h2,\r\n  .virtue-life-badge-gif-content h2,\r\n  .hep-features-gif-content h2 {\r\n    font-size: 24px;\r\n  }\r\n  .clinic-gif-content p,\r\n  .security-reliability-gif-content p,\r\n  .virtue-life-badge-gif-content p,\r\n  .hep-features-gif-content p {\r\n    font-size: 14px;\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .center-title-part {\r\n    max-width: 100%;\r\n  }\r\n  .center-title-part h2 {\r\n    font-size: 24px;\r\n    line-height: 35px;\r\n  }\r\n  .center-title-part p {\r\n    font-size: 14px;\r\n    margin-top: 0px;\r\n  }\r\n  .next-card {\r\n    margin-top: 1rem;\r\n  }\r\n  .image-part img {\r\n    margin-top: 2rem;\r\n  }\r\n  .card-row {\r\n    margin-top: 0rem;\r\n  }\r\n  .try-virtue-life-today-section {\r\n    padding: 2rem 0;\r\n  }\r\n  .try-virtue-life-today-content {\r\n    padding-top: 2rem;\r\n    padding-bottom: 2rem;\r\n  }\r\n  .try-virtue-life-today-text {\r\n    font-size: 30px;\r\n    line-height: 40px;\r\n    margin-bottom: 16px;\r\n  }\r\n  .try-virtue-life-today-heading {\r\n    font-size: 24px;\r\n  }\r\n  .store-name button {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    width: 100%;\r\n  }\r\n\r\n  /* Unified Communication & Profile Management for Doctors section */\r\n  .ucpm-doctors-section {\r\n    padding: 2rem 0;\r\n  }\r\n\r\n  .ucpm-doctor-card {\r\n    padding: 1rem;\r\n  }\r\n  .ucpm-doctor-card h5 {\r\n    margin-bottom: 5px;\r\n  }\r\n  .ucpm-doctor-card p {\r\n    font-size: 14px;\r\n    margin-bottom: 0px;\r\n  }\r\n  /* step section */\r\n  .step-section {\r\n    padding: 2rem 0;\r\n  }\r\n  .step-section-data-card-grid {\r\n    padding-left: 0.8rem;\r\n    padding-right: 0.8rem;\r\n  }\r\n  .custom-card-step-section {\r\n    padding: 1rem;\r\n    margin: auto !important;\r\n  }\r\n  .custom-card-step-section h5 {\r\n    font-size: 16px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .custom-card-step-section p {\r\n    font-size: 14px;\r\n    margin-bottom: 0px !important;\r\n  }\r\n  .step-section-sequential-number-list {\r\n    width: 50px;\r\n    height: 50px;\r\n    font-size: 30px;\r\n  }\r\n  .number-margin {\r\n    margin: auto !important;\r\n  }\r\n  .step-button {\r\n    margin-top: 1rem;\r\n  }\r\n  .step-button button {\r\n    font-size: 14px;\r\n    width: 100%;\r\n  }\r\n\r\n  .virtue-life-core-values-section {\r\n    padding: 2rem 0;\r\n  }\r\n  .healthcare-systems-ul {\r\n    display: block;\r\n    padding: 0px;\r\n  }\r\n  .desktop-mobile-section {\r\n    padding: 2rem 0;\r\n  }\r\n  .exercise-protocol-title-part h2 {\r\n    font-size: 24px;\r\n    text-align: center;\r\n  }\r\n  .exercise-protocol-title-part p {\r\n    font-size: 14px;\r\n    margin-top: 5px;\r\n  }\r\n  .desktop-mobile-section .desktop-mobile-list-part ul {\r\n    display: block;\r\n    margin-bottom: 15px;\r\n    margin-top: 0px;\r\n  }\r\n  .app-play-button {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  .popover {\r\n    display: none !important;\r\n  }\r\n  .banner-image {\r\n    display: flex !important;\r\n    justify-content: center;\r\n    padding-top: 2rem;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .desktop-mobile-patient li {\r\n    font-size: 14px;\r\n  }\r\n  .global-scale-vertical-divider {\r\n    height: 50px;\r\n  }\r\n\r\n  .global-scale-section {\r\n    padding: 2rem 0;\r\n  }\r\n\r\n  .global-scale-title-part {\r\n    text-align: center;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .global-scale-title-part h2 {\r\n    font-size: 24px;\r\n    line-height: 35px;\r\n  }\r\n\r\n  .global-scale-title-part p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .global-scale-content-part,\r\n  .streamlined-patient-section {\r\n    padding: 2rem 0;\r\n  }\r\n  .global-scale-content-part {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .global-scale-content-part .light-theme {\r\n    padding: 0px;\r\n  }\r\n\r\n  .see-more-content {\r\n    text-align: center;\r\n  }\r\n\r\n  .global-text {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n\r\n  .global-scale-button {\r\n    width: 100%;\r\n  }\r\n  .global-scale-statistic-text {\r\n    font-size: 20px;\r\n    line-height: 40px;\r\n  }\r\n\r\n  .global-scale-card {\r\n    padding: 15px 14px;\r\n    gap: 20px;\r\n    justify-content: center;\r\n  }\r\n  .global-scale-card-info {\r\n    text-align: center;\r\n  }\r\n\r\n  .global-scale-statistic-name {\r\n    font-size: 12px;\r\n    margin-top: 0px;\r\n    width: 70px;\r\n  }\r\n}\r\n\r\nhtml,\r\nbody {\r\n  max-width: 100% !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n\r\n/* Default button style */\r\n.accordion-button {\r\n  background-color: #fff;\r\n  color: #000; /* Black text by default */\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n/* Hover effect — orange background, white text */\r\n.accordion-button:hover {\r\n  background-color: #aaaaaa; /* medium orange */\r\n  color: #fff; /* white text on hover */\r\n}\r\n\r\n/* Active/expanded state — darker orange, white text */\r\n.accordion-button:not(.collapsed) {\r\n  background-color: #aaaaaa; /* deeper orange */\r\n  color: #fff;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n/* Remove all default focus/blue styles */\r\n.accordion-button:focus,\r\n.accordion-button:focus-visible {\r\n  outline: none;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
